import { MegaraxUri } from "../uri";
import { LegacyRedirect, redirect, uuidParam } from "./redirect";

export const adminRedirects: LegacyRedirect[] = [
  redirect("/historia", () => MegaraxUri("megarax://history")),
  redirect("/saved-view/:id", ({ id }) => {
    const viewId = uuidParam(id);
    return viewId ? MegaraxUri("megarax://crm/customer-lists/id/{id}", { id: viewId }) : undefined;
  }),
  redirect("/saved-views/:id", ({ id }) => {
    const viewId = uuidParam(id);
    return viewId ? MegaraxUri("megarax://crm/customer-lists/id/{id}", { id: viewId }) : undefined;
  }),
  redirect("/saved-views/id/:id", ({ id }) => {
    const viewId = uuidParam(id);
    return viewId ? MegaraxUri("megarax://crm/customer-lists/id/{id}", { id: viewId }) : undefined;
  }),

  redirect("/crm/zgloszenia/nowe", () => MegaraxUri("megarax://support/tickets/new")),
  redirect("/crm/zgloszenia/settings", () => MegaraxUri("megarax://support/settings")),
  redirect("/crm/zgloszenia/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://support/tickets/id/{id}", { id }) : undefined;
  }),
  redirect("/crm/zgloszenia", () => MegaraxUri("megarax://support/tickets")),
  redirect("/support/tickets/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://support/tickets/id/{id}", { id }) : undefined;
  }),

  redirect("/iam/groups/nowe", () => MegaraxUri("megarax://iam/groups/new")),
  redirect("/iam/accounts/email/:email/*", ({ email }) => MegaraxUri("megarax://iam/users/email/{email}", { email })),
  redirect("/iam/accounts/*", () => MegaraxUri("megarax://iam/users")),

  redirect("/dev/notifications/uuid/:uuid", ({ uuid }) => {
    const id = uuidParam(uuid);
    return id ? MegaraxUri("megarax://dev/notifications/id/{id}", { id }) : undefined;
  }),
];
